// extracted by mini-css-extract-plugin
module.exports = {"bouncingDot":"thinking_bouncingDot__L4S_E","bounce":"thinking_bounce__7viDc","thinking":"thinking_thinking__uzxBY"};